// extracted by mini-css-extract-plugin
export default {"circle":"index__circle__rIG4M"};